module.exports = __webpack_public_path__ + "static/1967-99a6bc778e16a2063e47a9c47448c7ea.webp";